import { createAsyncThunk } from '@reduxjs/toolkit';
//import Config from '../../../Config';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import { goToPage, setErrorPage, setSuccessType, setIsAlternativeAddon, updateMesh, setUpgradeSpeedList, setAddonId, setIsWhatsAppActive, setInfrastructureData, setIsDisplayMoreSpeedLink, setAddressDetails, setCreateSaleError } from './AddonsBlockSlice';


export const prepareSaleAsync = createAsyncThunk('addonsBlock/prepareSaleAsync', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {

        //------------------------------------
        // const params = { errorPage: 'NO_INTERNET_SPEED_PAGE', errorDescription: 'NO_INTERNET_SPEED_ERROR' };
        // thunkAPI.dispatch(setErrorPage(params));
        // return;
        //------------------------------------

        let state = thunkAPI.getState().addonsBlock;

        switch (state.flowType) {
            case 'service': {
                await thunkAPI.dispatch(getSalePricesAsync());
                state = thunkAPI.getState().addonsBlock;
                const addons = state?.saleCatalog?.addons;

                if (addons?.length > 0) {
                    let addon = addons?.find((x) => x.name == state.addonId && x.action == 'Existing');
                    if (addon) {
                        await thunkAPI.dispatch(setErrorPageAsync({ error: 'SERVICE_EXISTS_ERROR' }));
                        return;
                    }
                    //SERVICE_NOT_SUPPORTED_ERROR - TODO:check this
                    thunkAPI.dispatch(goToPage('servicePage'));
                }
                else {
                    await thunkAPI.dispatch(setErrorPageAsync({ error: 'PREPARE_SALE_ERROR' }));
                    return;
                }
            }
                break;
            case 'mesh': {
                await thunkAPI.dispatch(getSalePricesAsync());
                state = thunkAPI.getState().addonsBlock;
                const addons = state?.saleCatalog?.addons;

                if (addons?.length > 0) {
                    let addon = addons?.find((x) => x.action == 'Existing' && (x.name == 'MESH' || x.name == 'MESHUL' || x.name == 'MESHPR' || x.name == 'MESHPLUS'));
                    if (addon) {
                        await thunkAPI.dispatch(setErrorPageAsync({ error: 'SERVICE_EXISTS_ERROR' }));
                        return;
                    }

                    const checkJetOpenOrdersResult = await ProviderManager.getProviderData('checkJetOpenOrders', [state.subscriber.ban]);
                    if (checkJetOpenOrdersResult?.Body?.hasOpenOrders) {
                        await thunkAPI.dispatch(setErrorPageAsync({ error: 'EXISTS_ORDER_ERROR' }));
                        return;
                    }

                    var equipment = { 'ALLINONE': 'MESH', 'ALLINONEUF': 'MESHUL', 'B35': 'MESHUL', 'NETBOX': 'MESH', 'JSTARPRO': 'MESHPR', 'STARPLUS': 'MESHPLUS' };
                    const router = state?.saleCatalog?.routers?.find((x) => x.action == 'Existing');

                    if (equipment[router.name] == state.addonId) {
                        //equipment is fit
                        thunkAPI.dispatch(updateMesh({ name: state.addonId, count: 1, action: 'add' }));
                        await thunkAPI.dispatch(getSalePricesAsync());
                        thunkAPI.dispatch(goToPage('meshPage'));
                    }
                    else {
                        //equipment not fit
                        const alternativeAddonId = equipment[router.name];
                        thunkAPI.dispatch(setAddonId(alternativeAddonId));

                        const alternativeAddon = state?.saleCatalog?.addons.find(x => x.name == alternativeAddonId);
                        if (alternativeAddon) {
                            thunkAPI.dispatch(updateMesh({ name: alternativeAddon.name, count: 1, action: 'add' }));
                            await thunkAPI.dispatch(getSalePricesAsync());
                            thunkAPI.dispatch(setIsAlternativeAddon(true));
                            thunkAPI.dispatch(goToPage('meshPage'));
                        }
                        else {
                            await thunkAPI.dispatch(setErrorPageAsync({ error: 'EQUIPMENT_ERROR' }));
                        }
                    }
                }
                else {
                    await thunkAPI.dispatch(setErrorPageAsync({ error: 'PREPARE_SALE_ERROR' }));
                    return;
                }
            }
                break;
            case 'internetSpeed': {
                state = thunkAPI.getState().addonsBlock;
                const data = { cityName: state.subscriber.address.cityName, streetName: state.subscriber.address.streetName };
                const addressDetails = await ProviderManager.getProviderData('getAddressDetails', data);
                thunkAPI.dispatch(setAddressDetails(addressDetails?.Body));

                let entry = state.subscriber.address.entry ? state.subscriber.address.entry : '  ';
                if (entry.trim() == '' && addressDetails?.Body?.entryList && addressDetails?.Body?.entryList?.length > 0) {
                    entry = 'NONE'
                }
                const fiberResult = await ProviderManager.getProviderData('checkFiberAddressInfraStructure', [
                    addressDetails?.Body?.cityName || '0',
                    addressDetails?.Body?.citySemel || '0',
                    addressDetails?.Body?.streetName || '0',
                    addressDetails?.Body?.streetSemel || '0',
                    (addressDetails?.Body?.streetGisSemel ? addressDetails?.Body?.streetGisSemel : '0'),
                    state.subscriber.address.houseNumber || '0',
                    entry,
                    state.subscriber.address.apartment || '0',
                ]);

                if (!fiberResult?.Body?.entryList) {
                    await thunkAPI.dispatch(setErrorPageAsync({ error: 'INFRASTRUCTURE_NO_RESULTS_ERROR' }));
                    return;
                }

                if (!fiberResult?.Body?.entryList.length > 1) {
                    await thunkAPI.dispatch(setErrorPageAsync({ error: 'MORE_THEN_ONE_ENTRY_ERROR' }));
                    return;
                }

                let maxSpeed = fiberResult.Body.entryList[0].maxSpeed;
                let isXgspon = fiberResult.Body.entryList[0].technologyType == 'XGSPON';
                let infrastructure = fiberResult.Body.entryList[0].infrastructure;
                let gponExists = fiberResult.Body.entryList[0].gponExists;
                let distributionType = fiberResult.Body.entryList[0].distributionType;
                let packageRateCode = fiberResult.Body.entryList[0].packageRateCode?.substring(1);
                let packageRateCodeBezeq = '';

                if (state.subscriber.address.infrastructure == 'BF' || state.subscriber.address.infrastructure == 'BZ') {
                    const params = { ban: state.subscriber.ban, iipSeq: state.subscriber.iipSeq }
                    const bezeqResult = await ProviderManager.getProviderData('checkBezeqInfrastructure', params);

                    if (!bezeqResult?.Body) {
                        await thunkAPI.dispatch(setErrorPageAsync({ error: 'INFRASTRUCTURE_BEZEQ_NO_RESULTS_ERROR' }));
                        return;
                    }

                    maxSpeed = bezeqResult?.Body?.maxSpeed;
                    gponExists = bezeqResult?.Body?.gponExists; //this is for the link to upgrade
                    packageRateCodeBezeq = bezeqResult?.Body?.packageRateCode?.substring(1);
                }

                let infrastructureData = fiberResult.Body.entryList[0];
                infrastructureData.maxSpeed = maxSpeed;
                infrastructureData.gponExists = gponExists;
                infrastructureData.distributionType = distributionType;

                thunkAPI.dispatch(setInfrastructureData(infrastructureData));
                await thunkAPI.dispatch(getSalePricesAsync());

                state = thunkAPI.getState().addonsBlock;

                const internetSpeedList = state?.saleCatalog?.internetSpeedList;
                const offerSpeed = state?.saleCatalog?.upgradeOffer;
                const customerSpeed = internetSpeedList.find(x => x.action == 'Existing');

                if (offerSpeed) {

                    maxSpeed = offerSpeed.equipmentMaxSpeed;
                    let isDisplayMoreSpeedLink = offerSpeed.isDisplayMoreSpeedLink;
                    thunkAPI.dispatch(setIsDisplayMoreSpeedLink(isDisplayMoreSpeedLink));
                    let upgradeSpeedList = [];

                    if (offerSpeed?.choiceSpeedCount > 0) {

                        upgradeSpeedList = internetSpeedList.filter((x) => x.downloadSpeed > customerSpeed.downloadSpeed && x.downloadSpeed <= maxSpeed ||
                            (x.downloadSpeed == customerSpeed.downloadSpeed && x.uploadSpeed > customerSpeed.uploadSpeed));

                    }
                    else {
                        upgradeSpeedList = internetSpeedList.filter((x) => x.downloadSpeed == customerSpeed.downloadSpeed && x.uploadSpeed > customerSpeed.uploadSpeed);
                        //thunkAPI.dispatch(goToPage('internetSpeedPage'));

                    }
                    if (upgradeSpeedList.length == 0) {
                        await thunkAPI.dispatch(setErrorPageAsync({ error: 'NO_INTERNET_SPEED_ERROR' }));

                    }
                    else {
                        thunkAPI.dispatch(setUpgradeSpeedList(upgradeSpeedList));
                        thunkAPI.dispatch(goToPage('internetSpeedPage'));
                    }
                }
                else {
                    await thunkAPI.dispatch(setErrorPageAsync({ error: 'PREPARE_SALE_ERROR' }));
                    return;
                }


                // if (internetSpeedList) {
                //     let upgradeSpeedList = [];

                //     if (fiberResult?.Body?.entryList?.length > 0) {
                //         const customerSpeed = internetSpeedList.find(x => x.action == 'Existing');
                //         const customerRouter = state?.saleCatalog?.routers?.find((x) => x.action == 'Existing');

                //         if (state.subscriber.address.infrastructure == 'BF' && customerRouter?.name == 'ALLINONEUF' && maxSpeed >1000) {
                //             maxSpeed = 2500
                //         }else{
                //             maxSpeed = 1000
                //         }
                //         if (customerRouter?.name == 'ALLINONE' && maxSpeed > 1000) {
                //             maxSpeed = 1000;
                //         }
                //         if (state.subscriber.address.infrastructure == 'BZ' && customerRouter?.name == 'NETBOX' && maxSpeed > 100) {
                //             maxSpeed = 100;
                //         }
                //         if (state.subscriber.address.infrastructure == 'FB' && (isXgspon || gponExists == '1')) {
                //             maxSpeed = 1000;
                //         }

                //         upgradeSpeedList = internetSpeedList.filter((x) => x.downloadSpeed <= maxSpeed && x.downloadSpeed > customerSpeed.downloadSpeed || (x.downloadSpeed == customerSpeed.downloadSpeed && x.uploadSpeed > customerSpeed.uploadSpeed));

                //         //----------------- MoreSpeedLink -----------------
                //         let isDisplayMoreSpeedLink = false;

                //         if (state.subscriber.address.infrastructure == 'BZ' && (infrastructure == 'BC' || infrastructure == 'FB' || gponExists == '1')) {
                //             isDisplayMoreSpeedLink = true;
                //             console.log('subscriber.address.infrastructure == BZ && (infrastructure == BC || infrastructure == FB || gponExists == 1)');
                //         }
                //         if (state.subscriber.address.infrastructure == 'BZ' && customerRouter?.name == 'NETBOX' && packageRateCodeBezeq == '200') {
                //             isDisplayMoreSpeedLink = true;
                //             console.log('subscriber.address.infrastructure == BZ && customerRouter?.name == NETBOX && packageRateCodeBezeq == 200');
                //         }
                //         if (state.subscriber.address.infrastructure == 'BF' && packageRateCode == '5000') {
                //             isDisplayMoreSpeedLink = true;
                //             console.log('subscriber.address.infrastructure == BF && packageRateCode == 5000');
                //         }
                //         if (state.subscriber.address.infrastructure == 'BC' && (isXgspon || gponExists == '1')) {
                //             isDisplayMoreSpeedLink = true;
                //             console.log('subscriber.address.infrastructure == BC && (isXgspon || gponExists == 1)');
                //         }
                //         if (state.subscriber.address.infrastructure == 'BF' && customerRouter?.name == 'ALLINONE') {
                //             isDisplayMoreSpeedLink = true;
                //             console.log('subscriber.address.infrastructure == BF && customerRouter?.name == ALLINONE');
                //         }
                //         if (state.subscriber.address.infrastructure == 'FB' && customerSpeed.downloadSpeed <= 1000 && (isXgspon || gponExists == '1')) {
                //             isDisplayMoreSpeedLink = true;
                //             console.log('subscriber.address.infrastructure == FB && customerSpeed.downloadSpeed <= 1000 && (isXgspon || gponExists == 1');
                //         }

                //         thunkAPI.dispatch(setIsDisplayMoreSpeedLink(isDisplayMoreSpeedLink));
                //         //----------------- MoreSpeedLink -----------------
                //     }

                //     if (upgradeSpeedList.length > 0) {
                //         thunkAPI.dispatch(setUpgradeSpeedList(upgradeSpeedList));
                //         thunkAPI.dispatch(goToPage('internetSpeedPage'));
                //     }
                //     else {
                //         //thunkAPI.dispatch(goToPage('internetSpeedPage'));
                //         await thunkAPI.dispatch(setErrorPageAsync({ error: 'NO_INTERNET_SPEED_ERROR' }));
                //     }

                // }
                // else {
                //     await thunkAPI.dispatch(setErrorPageAsync({ error: 'PREPARE_SALE_ERROR' }));
                //     return;
                // }
            }
                break;
        }


    } catch (error) {
        await thunkAPI.dispatch(setErrorPageAsync({ error: 'PREPARE_SALE_ERROR' }));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});


export const getSalePricesAsync = createAsyncThunk('addonsBlock/getSalePricesAsync', async (data, thunkAPI) => {
    if (data?.isDisplayLoader) {
        thunkAPI.dispatch(showAppLoader());
    }
    try {
        const state = thunkAPI.getState().addonsBlock;
        const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;
        const addons = state.flowType == 'mesh' ? ['MESH', 'MESHUL', 'MESHPR'] : [state.addonId];

        let productList = [];
        productList.push(
            ...state.selectedMeshList,
            ...(Object.keys(state.selectedService).length === 0 ? [] : [state.selectedService]),
            ...(Object.keys(state.selectedSpeed).length === 0 ? [] : [state.selectedSpeed]),
        );

        const isCalcSupplyMethod = (state.addonId == 'MESH' || state.addonId == 'MESHUL' || state.addonId == 'MESHPR');
        const params = {
            offerId: state.subscriber.offerId,
            saleType: state.saleType,
            infraType: state.subscriber.address.infrastructure,
            productList: productList,
            calcSupplyMethod: isCalcSupplyMethod,
            selectedAddress: {
                maxSpeed: state.infrastructureData.maxSpeed,
                gponExists: state.infrastructureData.gponExists,
                technologyType: state.infrastructureData.technologyType
            },
            general: {
                orderType: 'CHANGE',
            },
            personalInfo: {
                idNumber: userDetails.IDNumber,
                otpPhone: userDetails.contactNumber,
                accountId: state.subscriber.consumerId,
                ban: state.subscriber.ban
            },
            cellularInfo: {
                cellularType: '',
                cellularNumber: '',
                transferNumber: '',
            },
            addons: addons,
            gisha: [],
            orders: [],
        };

        const result = await ProviderManager.getProviderData('getSalePrices', params);
        //thunkAPI.dispatch(setSuccessType('INSTALL_MESH_SUCCESS')); return;//TODO:delete this

        return result?.Body;
    } catch (error) {
        await thunkAPI.dispatch(setErrorPageAsync({ error: 'SALE_PRICE_ERROR' }));
    } finally {
        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(hideAppLoader());
        }
    }
});


export const createSaleAsync = createAsyncThunk('addonsBlock/createSaleAsync', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().addonsBlock;
    const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;
    const addons = state.flowType == 'mesh' ? ['MESH', 'MESHUL', 'MESHPR'] : [state.addonId];

    try {
        let productList = [];
        productList.push(
            ...state.selectedMeshList,
            ...(Object.keys(state.selectedService).length === 0 ? [] : [state.selectedService]),
            ...(Object.keys(state.selectedSpeed).length === 0 ? [] : [state.selectedSpeed]),
        );

        if (state.flowType == 'internetSpeed') {
            const customerSpeed = state.saleCatalog?.internetSpeedList?.find(x => x.action == 'Existing');
            if (customerSpeed) { productList.push({ name: customerSpeed.name, count: 0 }); }
        }

        let supplyMethod = 'No Supply';
        let isCalcSupplyMethod = false;
        if (state.flowType == 'mesh') {
            supplyMethod = 'Technician';
            isCalcSupplyMethod = true;
        }

        const primaryEmail = state.newPrimaryEmail ? state.newPrimaryEmail : state.subscriber.primaryEmail;

        let params = {
            offerId: state.subscriber.offerId,
            saleType: state.saleType,
            infraType: state.subscriber.address.infrastructure,
            productList: productList,
            calcSupplyMethod: isCalcSupplyMethod,
            general: {
                supplyMethod: supplyMethod, //Technician|Delivery|No Supply|SelfPickUp
                //calcPriceInd: false,
                orderType: 'CHANGE',
                //serviceAction: 'ADD', //ADD/REMOVE
                //billingAccountIdType: 'I',
            },
            customerExposure: {
                // decisionSeq: state.checkUserResponse.customerExposure?.decisionSeq,
                isKosher: state.subscriber.isKosherSubscriber,
                isCellularPhone: state.subscriber.isCellularPhone,
                summaryEmail: primaryEmail,
            },
            selectedAddress: {
                city: state.addressDetails?.citySemel,
                cityName: state.subscriber.address?.cityName,
                street: state.addressDetails?.streetSemel,
                streetName: state.subscriber.address?.streetName,
                streetGisSemel: state.addressDetails?.streetGisSemel,
                houseNumber: state.subscriber.address?.houseNumber,
                aptNumber: state.subscriber.address?.apartment,
                // entrance: state.addressPage.selectedAddress?.entry,
                floor: 0,
                postalCode: state.subscriber.address?.zipCode,
                // isChanged: false,
                // updateCustomerAddress: false,
                // tashtitType: state.addressPage.selectedEntry?.infrastructure,
                gponBuildingType: state.infrastructureData.gponBuildingType,
                distributionType: state.addressDetails?.distributionType,
                socketStatus: state.infrastructureData.socketStatus,
                // siteType: state.addressPage.selectedEntry?.siteType,
                gponExists: state.infrastructureData.gponExists,
                portType: state.infrastructureData.portType,
                internalRequestId: state.infrastructureData.internalRequestId,
                maxSpeed: state.infrastructureData.maxSpeed,
                infrastructure: state.subscriber.address?.infrastructure,
                packageRateCode: state.infrastructureData.packageRateCode,
                changeSpeedInd: (state.flowType == 'internetSpeed'), // ב PROVIDE יש לשלוח FALSE
                // bezeqFiberExist: false, // ממשק 1445 איתור לקוח - אם אותר לקוח בבזק סיבים יש לשלוח את הערך true אם לא אותר לקוח יש לשלוח false
                seq: state.subscriber.iipSeq,
                technologyType: state.infrastructureData.technologyType
            },
            workAddress: {
                cityName: state.addressDetails?.cityName ? state.addressDetails?.cityName : state.subscriber?.address?.cityName,
                streetName: state.addressDetails?.streetName ? state.addressDetails?.streetName : state.subscriber?.address?.streetName,
                houseNumber: state.subscriber?.address?.houseNumber,
                aptNumber: state.subscriber?.address?.apartment
            },
            personalInfo: {
                isCustomerExists: true,
                idNumber: userDetails.IDNumber,
                otpPhone: userDetails.contactNumber,
                accountId: state.subscriber.consumerId,
                ban: state.subscriber.ban,
                primaryEmail: state.newPrimaryEmail,
                firstName: userDetails.firstName,
                lastName: userDetails.lastName,
            },
            techVisitInfo: {
                startDate: state.technician.selectedTechnicianTime.startDate,
                endDate: state.technician.selectedTechnicianTime.endDate,
                round: '',
                taskType: state.saleCatalog?.supplyMethods?.find((x) => x.name == 'Technician')?.techDescription
            },
            haveTechnicianVisit: false,
            cellularInfo: {
                cellularType: '',
                cellularNumber: '',
                transferNumber: '',
            },
            addons: addons,
            gisha: [],
            orders: [],
            addonFlowType: state.flowType
        };

        // if (state.saleType == 'app' && state.flowType == 'existsCustomer') {
        //     params.selectedAddress.city = state.userAddressPage.selectedAddress?.cityCode;
        //     params.selectedAddress.cityName = state.userAddressPage.selectedAddress?.city;
        //     params.selectedAddress.street = state.userAddressPage.selectedAddress?.streetCode;
        //     params.selectedAddress.streetName = state.userAddressPage.selectedAddress?.streetName;
        //     params.selectedAddress.houseNumber = state.userAddressPage.selectedAddress?.houseNum;
        //     params.selectedAddress.aptNumber = state.userAddressPage.selectedAddress?.flatNum;
        //     params.selectedAddress.postalCode = state.userAddressPage.selectedAddress?.zipCode;
        // }

        const result = await ProviderManager.getProviderData('createSale', params);

        if (result.Header?.ReturnCode == 0 && result.Body?.isSuccess) {
            switch (state.flowType) {
                case 'service': thunkAPI.dispatch(setSuccessType('INSTALL_SERVICE_SUCCESS')); break;
                case 'mesh': thunkAPI.dispatch(setSuccessType('INSTALL_MESH_SUCCESS')); break;
                case 'internetSpeed': thunkAPI.dispatch(setSuccessType('INSTALL_INTERNET_SPEED_SUCCESS')); break;
            }
            let memoManualTxt = buildMemoText('', true, state);
            await thunkAPI.dispatch(createMemoAsync({ memoManualTxt: memoManualTxt }));
        } else {
            thunkAPI.dispatch(setCreateSaleError(result.Body?.codeError));
            await thunkAPI.dispatch(setErrorPageAsync({ error: 'CREATE_SALE_ERROR' }));
        }
        return result.Body;
    } catch (error) {
        thunkAPI.dispatch(setCreateSaleError('general error'));
        await thunkAPI.dispatch(setErrorPageAsync({ error: 'CREATE_SALE_ERROR' }));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});



export const getTechnicianTimesAsync = createAsyncThunk('addonsBlock/getTechnicianTimesAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        await thunkAPI.dispatch(getSalePricesAsync());
        const state = thunkAPI.getState().addonsBlock;

        const supplyMethod = state.saleCatalog?.supplyMethods?.find((x) => x.name == 'Technician');
        if (!supplyMethod) {
            await thunkAPI.dispatch(setErrorPageAsync({ error: 'TECHNICIAN_SUPPLY_METHOD_ERROR' }));
            return;
        }

        const params = {
            cityName: state.subscriber?.address?.cityName,
            cityCode: state.subscriber?.address?.cityCode,
            streetCode: state.subscriber?.address?.streetCode,
            entranceNo: '',
            taskType: supplyMethod.techDescription,
            callId: '',
            zipCode: state.subscriber?.address?.zipCode,
            addHours: '48',
            distributionType: '',
            infrastructure: state.subscriber?.address?.infrastructure,
            iipSeq: state.subscriber?.iipSeq,
            houseNumber: state.subscriber?.address?.houseNumber,
            apartment: state.subscriber?.address?.apartment
        };

        const result = await ProviderManager.getProviderData('getTechnicianTimes', params);
        thunkAPI.dispatch(goToPage('technicianPage'));

        return result?.Body;
    } catch (error) {
        await thunkAPI.dispatch(setErrorPageAsync({ error: 'TECHNICIAN_TIMES_ERROR' }));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});


export const checkIfWhatsAppActiveAsync = createAsyncThunk('addonsBlock/checkIfWhatsAppActiveAsync', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().addonsBlock;
        if (!state.isDisplayWhatsApp) { return false; }

        const whatsResult = await ProviderManager.getProviderData('getSelfCareWhatsAppActivity', []);
        const isWhatsAppActive = whatsResult?.Body;
        thunkAPI.dispatch(setIsWhatsAppActive(isWhatsAppActive));
        return isWhatsAppActive;
    } catch (error) {

    } finally {

    }
});


export const createWhatsAppCallAsync = createAsyncThunk('addonsBlock/createWhatsAppCallAsync', async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
        const state = thunkAPI.getState().addonsBlock;
        const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;

        let messageText = '';
        switch (state.flowType) {
            case 'service':
                messageText = `כישלון בתהליך רכישת Addon ${state.addonId} באיזור האישי`;
                break;
            case 'mesh':
                messageText = 'כישלון בתהליך רכישת mesh באיזור האישי';
                break;
            case 'internetSpeed':
                messageText = 'כישלון בתהליך שדרוג מהירות באיזור האישי';
                break;
        }

        var params = {
            phoneNumber: userDetails.contactNumber,
            consumerId: state.subscriber.consumerId,
            fullAddress: '',
            messageText: messageText
        }

        const result = await ProviderManager.getProviderData('selfCareOpenWhatsApp', params);

        // if (result?.Body?.isSuccess) {
        //     thunkAPI.dispatch(setSuccessType('WHATSAPP_SUCCESS'));
        // }

        thunkAPI.dispatch(setSuccessType('WHATSAPP_SUCCESS'));

        return result?.Body;

    } catch (error) {

    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});


export const createWorkOrderAsync = createAsyncThunk('addonsBlock/createWorkOrderAsync', async (data, thunkAPI) => {
    if (data?.isDisplayLoader) {
        thunkAPI.dispatch(showAppLoader());
    }

    try {
        const state = thunkAPI.getState().addonsBlock;
        const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;

        let serviceName = '';

        switch (state.flowType) {
            case 'service':
                serviceName = 'הוספת שירות';
                break;
            case 'mesh':
                serviceName = 'הוספת MESH';
                break;
            case 'internetSpeed':
                serviceName = 'שינוי מהירות';
                break;
        }

        let request = {
            orderType: 'SELFCARE_ADDONS',
            identityNumber: userDetails.IDNumber,
            errorCode: 'CB11',
            errorDescription: `לקוח ביקש לבצע ${serviceName} דרך אתר ${window.Config.brand_Name_HE} `,
            subscriber: userDetails.contactNumber,
            banList: [],
            psidList: [],
            movingApartment: null,
            saleJet: null
        };

        const result = await ProviderManager.getProviderData('createWorkOrder', request);

        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(setSuccessType('LEAD_SUCCESS'));
        }

        return result?.Body;

    } catch (error) {

    } finally {
        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(hideAppLoader());
        }
    }
});


export const createMemoAsync = createAsyncThunk('addonsBlock/createMemoAsync', async (data, thunkAPI) => {
    try {
        const params = {
            memoType: 'SER2',
            memoManualTxt: data.memoManualTxt,
        };

        ProviderManager.getProviderData('createMemo', params);
    }
    catch {

    } finally {

    }
});


export const setErrorPageAsync = createAsyncThunk('addonsBlock/setErrorPageAsync', async (data, thunkAPI) => {

    if (data.isDisplayLoader) {
        thunkAPI.dispatch(showAppLoader());
    }

    const whatsAppResult = await thunkAPI.dispatch(checkIfWhatsAppActiveAsync());
    const state = thunkAPI.getState().addonsBlock;

    let errorPage = '';

    try {
        const state = thunkAPI.getState().addonsBlock;

        switch (data.error) {
            case 'NO_SUBSCRIBER_ERROR':
                errorPage = 'NO_SUBSCRIBER_PAGE';
                break;
            case 'SERVICE_EXISTS_ERROR':
                errorPage = 'SERVICE_EXISTS_PAGE';
                break;
            case 'NO_INTERNET_SPEED_ERROR':
                errorPage = 'NO_INTERNET_SPEED_PAGE';
                break;
            case 'EXISTS_ORDER_ERROR':
                errorPage = 'EXISTS_ORDER_PAGE';
                break;
            case 'PAYMENT_OR_DEBT_ERROR':
                errorPage = 'PAYMENT_OR_DEBT_PAGE';
                break;
            case 'SERVICE_NOT_SUPPORTED_ERROR':
                errorPage = 'SERVICE_NOT_SUPPORTED_PAGE';
                break;
            case 'NOT_JET_CUSTOMER_ERROR':
            case 'EQUIPMENT_ERROR':
            case 'INFRASTRUCTURE_NO_RESULTS_ERROR':
            case 'MORE_THEN_ONE_ENTRY_ERROR':
            case 'INFRASTRUCTURE_BEZEQ_NO_RESULTS_ERROR':
            case 'PREPARE_SALE_ERROR':
            case 'SALE_PRICE_ERROR':
            case 'TECHNICIAN_TIMES_ERROR':
            case 'TECHNICIAN_SUPPLY_METHOD_ERROR':
                errorPage = 'GENERAL_ERROR_PAGE';
                break;
            case 'MORE_SPEED_ERROR':
            case 'CREATE_SALE_ERROR':
                if (state.isWhatsAppActive) {
                    errorPage = 'WHATSAPP_PAGE';
                }
                else {
                    errorPage = 'WORK_ORDER_PAGE';
                }
                let memoManualTxt = buildMemoText(data.error, false, state);
                await thunkAPI.dispatch(createMemoAsync({ memoManualTxt: memoManualTxt }));
                break;
        }

        if (errorPage == 'WORK_ORDER_PAGE') {
            const workOrderResult = await thunkAPI.dispatch(createWorkOrderAsync());
        }


    } catch (error) {

    } finally {
        if (data.isDisplayLoader) {
            thunkAPI.dispatch(hideAppLoader());
        }
    }

    const params = { errorPage: errorPage, errorDescription: data.error };
    thunkAPI.dispatch(setErrorPage(params));

});


function buildMemoText(error, isSuccess, state) {
    let memoManualTxt = '';
    let ban = state.subscriber.ban;
    let serviceName = '';
    let selectedTechnicianTimeDisplay = state.technician?.selectedTechnicianTimeDisplay;
    let errorMessage = state.createSaleError;
    const customerSpeed = state.saleCatalog?.internetSpeedList?.find(x => x.action == 'Existing');
    const selectedSpeed = state.saleCatalog?.internetSpeedList?.find(x => x.name == state.selectedSpeed?.name);

    if (error == 'MORE_SPEED_ERROR') {
        memoManualTxt = `כישלון בהחלפת מהירות נייח דרך האתר ללקוח קיים: הלקוח ביקש לשדרג מהירות מ-${customerSpeed?.downloadSpeed + '/' + customerSpeed?.uploadSpeed} (מהירות הורדה/מהירות העלאה) באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}. הופנה לנציג מאחר ונדרשת החלפת ציוד /תשתית.`;
        return memoManualTxt;
    }

    switch (state.flowType) {
        case 'service':
            serviceName = state.selectedService?.name;
            if (isSuccess) {
                memoManualTxt = `הצלחה בהתקנת שירות ADDON נייח דרך האתר ללקוח קיים: הלקוח התקין שירות ${serviceName} באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}.`;
            }
            else {
                memoManualTxt = `כישלון בהתקנת שירות ADDON נייח דרך האתר ללקוח קיים: הלקוח ביקש להתקין שירות ${serviceName}. הלקוח לא סיים את התהליך עקב כשלון בשלב פתיחת הזמנה ${errorMessage} באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}.`;
            }
            break;
        case 'mesh':
            serviceName = state.selectedMeshList[0]?.name;
            if (isSuccess) {
                memoManualTxt = `הצלחה בהזמנת ציוד MESH נייח דרך האתר ללקוח קיים: הלקוח הזמין ציוד MESH מסוג ${serviceName} באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}. מועד הטכנאי שתואם ${selectedTechnicianTimeDisplay}.`;
            }
            else {
                memoManualTxt = `כישלון בהתקנת שירות ADDON נייח דרך האתר ללקוח קיים: הלקוח ביקש להזמין ציוד MESH מסוג ${serviceName} באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}. מועד הטכנאי שבחר ${selectedTechnicianTimeDisplay}. הלקוח לא סיים את התהליך עקב כשלון בשלב פתיחת הזמנה ${errorMessage}`;
            }
            break;
        case 'internetSpeed':
            serviceName = state.selectedSpeed?.name;
            if (isSuccess) {
                memoManualTxt = `הצלחה בהחלפת מהירות נייח דרך האתר ללקוח קיים: הלקוח שדרג מהירות מ-${customerSpeed?.downloadSpeed + '/' + customerSpeed?.uploadSpeed} ל-${selectedSpeed?.downloadSpeed + '/' + selectedSpeed?.uploadSpeed} באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}.`;
            }
            else {
                memoManualTxt = `כישלון בהחלפת מהירות נייח דרך האתר ללקוח קיים:  הלקוח ביקש לשדרג מהירות מ-${customerSpeed?.downloadSpeed + '/' + customerSpeed?.uploadSpeed} ל-${selectedSpeed?.downloadSpeed + '/' + selectedSpeed?.uploadSpeed} באתר ${window.Config.brand_Name_HE} בחשבון חיוב מספר ${ban}. הלקוח לא סיים את התהליך עקב כשלון בשלב פתיחת הזמנה ${errorMessage}`;
            }
            break;
    }

    return memoManualTxt;
}
